module.exports = __webpack_public_path__ + "static/media/tt_commons_medium-webfont.d43b3341.woff";